import Vue from "vue";
import Vuex from "vuex"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);

Vue.use(Vuex);//挂载

const store = new Vuex.Store({
    state:{
        //登录存储
        LoginStorage: JSON.parse(localStorage.getItem('TTxq')) || -1,
        vipshow:false,
        teenagerMode: JSON.parse(localStorage.getItem('teenagerMode')) || false
    },
    mutations:{
        //修改登录的存储信息
        LoginModification(state,w){
            state.LoginStorage = w;
        },
        //设置充值弹窗显示状态
        setVipshow(state, value){
            if (state.teenagerMode) {
                alert('未成年人模式下禁止充值');
                // console.log('未成年人模式下禁止充值');
                return
            }
            state.vipshow = value;
        },
        setTeenagerMode(state, value) {
            state.teenagerMode = value
        }
    }
});

export default store